var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unicon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.getSize,"height":_vm.getSize,"viewBox":"0 0 24 24","fill":_vm.fill},domProps:{"innerHTML":_vm._s(_vm.icon)},on:{"click":function($event){return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }